import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { Spinner } from '@/components/app';
import { TenantDetailsFormDataMicrosoftPartner } from '@/common/viewModels/tenantDetails/form/data/TenantDetailsFormDataMicrosoftPartner';
import { TenantDetailsFormStateMicrosoftPartner } from '@/common/viewModels/tenantDetails/form/state/TenantDetailsFormStateMicrosoftPartner';
import {TelstraUIVueTooltip, TelstraUIVueSvg, Button} from '@/external/telstra-ui-vue/components';
@Component({
  components: {
    Spinner,
    TelstraUIVueTooltip,
    TelstraUIVueSvg,
    Button,
  },
})

export default class TenantDetailsMicrosoftPartner extends Vue {
  @Prop({ required: true }) data!: TenantDetailsFormDataMicrosoftPartner;
  @Prop({ required: true }) state!: TenantDetailsFormStateMicrosoftPartner;
  @Prop({ required: true }) isLoading!: boolean;

  get mpnInformationAvailable(): boolean {
    return this.data && (this.data.mpnId || '').length > 0 && (this.data.mpnName || '').length > 0;
  }

  get readOnlyMpnInformation(): boolean {
    return (this.mpnInformationAvailable || this.isDataLoading);
  }

  get isDataLoading(): boolean {
    return ((this.data && this.data.loading) || this.isLoading);
  }

  get disableMpnIdAdd(): boolean {
    return this.isDataLoading || (this.data && (this.data.mpnId || '').trim().length === 0);
  }

  @Emit()
  onMicrosoftPartnerInput(mpnId: string): void {
    this.$emit('microsoftPartnerInput', mpnId);
  }

  @Emit()
  onAddMicrosoftPartnerClick(): void {
    this.$emit('addMicrosoftPartnerClick');
  }

  @Emit()
  onEditMicrosoftPartnerClick(): void {
    this.$emit('editMicrosoftPartnerClick');
  }

  @Emit()
  onRemoveMicrosoftPartnerClick(): void {
    this.$emit('removeMicrosoftPartnerClick');
  }

  tooltipClose(): void {
    (this.$refs.tooltipRef as any).callDeactivate();
  }
}
